export {default as quadtree} from "./src/quadtree";



//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/d3-quadtree/index.js
// module id = ../../../../d3-quadtree/index.js
// module chunks = 4